import React from 'react';
import { PencilIcon, TrashIcon } from './Icons';

function PresetCard({ preset, onActivate, onEdit, onDelete }) {
  return (
    <div className="preset-row">
      <button
        className={`preset-select ${preset.is_active ? 'selected' : ''}`}
        onClick={() => !preset.is_active && onActivate(preset.id)}
        title={preset.is_active ? 'This card is live' : 'Make this card live'}
        aria-label={preset.is_active ? `${preset.name} is live` : `Make ${preset.name} live`}
      />

      <div className="preset-main">
        <div className="preset-title-row">
          <span className="preset-name">{preset.name}</span>
          {preset.is_active && <span className="badge-live">Live</span>}
        </div>
        <div className="preset-meta">
          {preset.first_name} {preset.last_name} · {preset.phone}
        </div>
      </div>

      <div className="preset-row-actions">
        <button
          className="icon-btn"
          onClick={() => onEdit(preset)}
          title="Edit card"
          aria-label={`Edit ${preset.name}`}
        >
          <PencilIcon />
        </button>
        <button
          className="icon-btn danger"
          onClick={() => onDelete(preset.id)}
          title="Delete card"
          aria-label={`Delete ${preset.name}`}
        >
          <TrashIcon />
        </button>
      </div>
    </div>
  );
}

export default PresetCard;
